import React, { Component } from 'react';
import Axios from 'axios';
import ProductSelector from '../product-selector/ProductSelector';
const elementary = require('../../vendor/elementary.js');

class TASelector extends Component {
	constructor(props) {
		super(props);

		this.state = {
			title: 'Find a Tools & Accessories Product',
			filters: [],
			products: [],
			mod: 'tools-and-accessories'
		}
	}

	componentDidMount() {
		var compScope = this;

		// Get selector filters data
		Axios.get(this.props.filtersUrl)
			.then(function(response) {
				compScope.setState({
					filters: response.data
				})
			})
			.catch(function(error) {
				console.log('Error:', error);
			});

		// Get selector product data
		Axios.get(this.props.productTypesUrl)
			.then(function(response) {
				compScope.setState({
					products: response.data
				});
			})
			.catch(function(error) {
				console.log('Error:', error);
			});
	}

	render() {
		return (
			<div>
				<ProductSelector
					title={ this.state.title }
					filters={ this.state.filters }
					products={ this.state.products }
					productTypes={true}
					mod={ this.state.mod } />
			</div>
		);
	}
}

export default TASelector;
